import { Reveal } from "./Reveal";
import { Logo } from "./Logo";

export const FinalCta = ({ onApply }) => (
  <section data-testid="final-cta-section" className="py-20 sm:py-28 lg:py-36 bg-[#241E1A] text-[#FBF8F3] relative overflow-hidden">
    <div className="max-w-4xl mx-auto px-4 sm:px-8 text-center">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C69C6D] mb-6">Your next step</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.12] font-medium">
          You did the work to change your life.
          <span className="block mt-2 italic text-[#C69C6D]">This is how it finally reaches her.</span>
        </h2>
        <p className="mt-8 text-base sm:text-lg text-[#FBF8F3]/70 max-w-xl mx-auto leading-relaxed">
          A 6-month private 1:1 partnership for mothers of children ages 1–5.
          Limited spots — every application is personally reviewed by Shellie.
        </p>
        <div
          data-testid="guarantee-block"
          className="mt-10 max-w-xl mx-auto rounded-2xl border border-[#FBF8F3]/15 bg-[#FBF8F3]/5 p-6 sm:p-7 text-left"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C69C6D] mb-2">My guarantee</p>
          <p className="text-sm sm:text-base leading-relaxed text-[#FBF8F3]/80">
            Show up for the first 60 days: use your family phrase map and message me when you're
            stuck. If you still don't feel calmer and clearer in your hard moments, I'll keep
            supporting you for an extra month at no charge.
          </p>
        </div>
        <p className="mt-8 text-base sm:text-lg text-[#FBF8F3]/70 max-w-xl mx-auto leading-relaxed">
          This is a significant private investment, and I treat it that way. I review every
          application personally, and I choose moms based on fit, not first come, first served. If
          it feels like we're a match, we'll talk through everything on a call.
        </p>
        <button
          data-testid="final-cta-apply-button"
          onClick={onApply}
          className="mt-10 rounded-full bg-[#8C4A32] text-[#FBF8F3] px-10 py-4 text-base font-semibold tracking-wide transition-all duration-300 hover:bg-[#733B27] hover:scale-[1.03]"
        >
          Apply for Legacy Language Architecture
        </button>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#241E1A] border-t border-[#FBF8F3]/10 py-10">
    <div className="max-w-6xl mx-auto px-4 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-5">
      <div className="flex items-center gap-3">
        <Logo size={28} />
        <p className="text-sm text-[#FBF8F3]/60">
          Legacy Language Architecture · <span className="font-script text-lg text-[#C69C6D]">Shellie Davis</span>, M.S., CCC-SLP
        </p>
      </div>
      <p className="text-xs text-[#FBF8F3]/40 tracking-wide">
        Parent coaching, not therapy. © {new Date().getFullYear()} All rights reserved.
      </p>
    </div>
  </footer>
);

export const StickyCta = ({ onApply }) => (
  <div
    data-testid="sticky-mobile-cta"
    className="fixed bottom-0 left-0 right-0 z-40 sm:hidden backdrop-blur-md bg-[#FBF8F3]/90 border-t border-[#E6DEC3] px-4 py-3"
  >
    <button
      data-testid="sticky-mobile-apply-button"
      onClick={onApply}
      className="w-full rounded-full bg-[#8C4A32] text-[#FBF8F3] py-3.5 text-sm font-semibold tracking-wide transition-colors duration-300 active:bg-[#733B27]"
    >
      Apply for the 1:1 Partnership
    </button>
  </div>
);
